import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";

export const refSiteLayoutDtoSchema = z.object({
  id: branded.siteLayoutId,
  description: z.string(),
  translationKey: z.string().nullable(),
  refTypeSiteId: branded.siteTypeId,
});

export type TRefSiteLayoutDto = z.infer<typeof refSiteLayoutDtoSchema>;
